"use client";

import React from "react";
import { Info, X } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const categories = [{
  id: "vorspeisen",
  label: "Core Divisions"
}, {
  id: "klassiker",
  label: "Industrial Incubation"
}, {
  id: "saisonales",
  label: "Innovation Research Institute"
}, {
  id: "weine",
  label: "Financial Capital"
}];
const menuItems = [{
  id: 1,
  categoryId: "vorspeisen",
  title: "STI (China) Group",
  description: "Deeply rooted in the Chinese market, connecting China-Singapore resources to provide comprehensive strategic support and capital empowerment for high-growth enterprises.",
  price: "Core Division",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/sti_china_headquarters.png",
  allergens: "Strategic Investment, Resource Integration, Market Access"
}, {
  id: 2,
  categoryId: "vorspeisen",
  title: "Luxury Goods Division",
  description: "Integrating technology with traditional craftsmanship to create a high-end luxury ecosystem covering watches, jewelry, and premium lifestyles.",
  price: "Premium Consumption",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/luxury_watch_movement.png",
  allergens: "Brand Management, Tech Empowerment, Global Supply Chain"
}, {
  id: 3,
  categoryId: "klassiker",
  title: "Media Division",
  description: "Professional MCN operations and brand communication, enhancing international influence and market penetration through digital means.",
  price: "Brand Communication",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/media_mcn_studio.png",
  allergens: "Content Creation, Traffic Operations, Brand Globalization"
}, {
  id: 4,
  categoryId: "klassiker",
  title: "Internet Division",
  description: "Focusing on cutting-edge internet product development, utilizing AI and big data to drive industrial upgrades and business model innovation.",
  price: "Tech Driven",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/internet_tech_innovation.png",
  allergens: "Software Development, Data Analysis, Platform Operations"
}, {
  id: 5,
  categoryId: "saisonales",
  title: "SCI International Institute",
  description: "An international think tank co-established by China and Singapore, dedicated to frontier technology research and industrial trend analysis.",
  price: "Think Tank",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/sci_research_institute.png",
  allergens: "Academic Exchange, Policy Research, Tech Incubation"
}, {
  id: 6,
  categoryId: "saisonales",
  title: "Incubation & Management",
  description: "From high-quality project incubation to full lifecycle management, helping startups rapidly grow into industry leaders.",
  price: "Project Management",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/industrial_incubation_center.png",
  allergens: "Startup Mentoring, Capital Matching, Operational Optimization"
}, {
  id: 7,
  categoryId: "weine",
  title: "Financial Division",
  description: "Covering private equity and asset management, achieving long-term steady asset appreciation through professional capital operations.",
  price: "Capital Operations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/financial_investment_banking.png",
  allergens: "Risk Control, Asset Allocation, Equity Investment"
}, {
  id: 8,
  categoryId: "weine",
  title: "Investment Holding",
  description: "Diversified multinational investment layout, selecting high-quality targets globally to build an influential investment platform.",
  price: "Global Layout",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/global_investment_holding.png",
  allergens: "Cross-border M&A, Strategic Holding, Value Investment"
}];
export default function UnsereKarte() {
  return <section data-section-id="234008" id="group-business-portfolio" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 min-h-screen flex flex-col items-center">
      <div className="max-w-4xl w-full mx-auto space-y-12">
        <div className="text-center space-y-4">
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-primary">
            Group Business Portfolio
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Explore STI Group's diversified industrial layout. Click on each sector to learn about our strategic investments and innovative practices worldwide.
          </p>
        </div>

        <Tabs defaultValue="vorspeisen" className="w-full flex flex-col items-center">
          <TabsList className="mb-12 bg-transparent border-b border-border p-0 h-auto w-full justify-start sm:justify-center overflow-x-auto flex-nowrap">
            {categories.map((category, i) => <TabsTrigger key={category.id} data-index={i} value={category.id} className="border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none px-6 py-4 text-lg font-default tracking-wide uppercase transition-colors hover:text-primary/80">
                {category.label}
              </TabsTrigger>)}
          </TabsList>

          {categories.map((category, i) => {
          const categoryItems = menuItems.filter(item => item.categoryId === category.id);
          return <TabsContent key={category.id} data-index={i} value={category.id} className="w-full mt-0 focus-visible:outline-none focus-visible:ring-0">
                <div className="grid grid-cols-1 gap-8">
                  {categoryItems.map((item, j) => <Dialog key={item.id}>
                      <DialogTrigger asChild data-index={j}>
                        <button className="w-full text-left group flex flex-col sm:flex-row sm:items-baseline justify-between gap-4 p-4 -mx-4 rounded-lg transition-colors hover:bg-accent/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
                          <div className="flex-1 space-y-2">
                            <div className="flex items-center gap-3">
                              <h3 className="font-default text-2xl font-semibold text-foreground group-hover:text-primary transition-colors">
                                {item.title}
                              </h3>
                              <Info className="size-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                            </div>
                            <p className="text-muted-foreground font-default text-base leading-relaxed max-w-2xl line-clamp-2 sm:line-clamp-none">
                              {item.description}
                            </p>
                          </div>
                          <div className="font-default text-xl font-medium text-primary whitespace-nowrap">
                            {item.price}
                          </div>
                        </button>
                      </DialogTrigger>
                      <DialogContent className="sm:max-w-2xl p-0 overflow-hidden bg-card border-border shadow-2xl">
                        <div className="relative h-64 sm:h-80 w-full bg-muted overflow-hidden">
                          <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                          <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/40 to-transparent" />
                        </div>
                        <div className="p-6 sm:p-8 space-y-6 relative z-10 -mt-16 backdrop-blur-sm bg-card/80">
                          <DialogHeader className="space-y-2 text-left">
                            <div className="flex justify-between items-start gap-4">
                              <DialogTitle className="font-default text-3xl sm:text-4xl font-bold text-foreground">
                                {item.title}
                              </DialogTitle>
                              <span className="font-default text-2xl font-semibold text-primary shrink-0">
                                {item.price}
                              </span>
                            </div>
                            <DialogDescription className="text-lg text-muted-foreground font-default leading-relaxed pt-2">
                              {item.description}
                            </DialogDescription>
                          </DialogHeader>
                          
                          <div className="pt-6 border-t border-border flex items-center gap-2 text-sm text-muted-foreground font-default">
                            <Info className="size-4 text-primary" />
                            <span>Core Capabilities: {item.allergens}</span>
                          </div>
                        </div>
                      </DialogContent>
                    </Dialog>)}
                </div>
              </TabsContent>;
        })}
        </Tabs>
      </div>
    </section>;
}